import React, { Component } from 'react';
import './App.css';
import whiteLogo from './white-logo.png'


class App extends Component {
    render() {
        return (
            <div className="App">
                <div className="header">
                    <a href='/'>
                        <div className="image-container">
                            <img
                            className="app-logo"
                            src={whiteLogo}
                            alt="My Inner Work Logo"
                            />
                        </div>
                        <div className="site-name">
                            My Inner Work
                        </div>
                    </a>
                </div>
                { this.props.children }
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js